import { render, staticRenderFns } from "./view-message.vue?vue&type=template&id=8e61f82e&"
import script from "./view-message.vue?vue&type=script&lang=js&"
export * from "./view-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports